import React, { useState } from 'react';
import toast from 'react-hot-toast';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import downloadReport from '../../utils/downloadReport';

// Outlined button that fetches an analytics CSV and saves it. Disabled with a
// spinner while it runs, since a cold cache can take up to a minute.
function DownloadButton({ path, fallbackName, label }) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      await downloadReport(path, fallbackName);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      className="inline-flex items-center gap-1 border border-gray-300 hover:border-claret-500 hover:text-claret-500 px-3 py-1.5 rounded-md text-gray-700 text-xs transition-colors disabled:opacity-60 disabled:hover:border-gray-300 disabled:hover:text-gray-700"
    >
      {busy ? (
        <span className="h-3.5 w-3.5 rounded-full border-2 border-gray-300 border-t-claret-500 animate-spin" />
      ) : (
        <FileDownloadOutlinedIcon fontSize="small" />
      )}
      <span>{busy ? 'Preparing…' : label}</span>
    </button>
  );
}

export default DownloadButton;
